import { Clapperboard, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = ({ onCreate }) => (
  <footer className="border-t border-white/10">
    <div className="relative overflow-hidden itm-grid-bg">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-12 py-20 text-center">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
          Ready to make your product <span className="text-[#FF2E63]">unskippable?</span>
        </h2>
        <p className="mt-4 text-slate-300 max-w-xl mx-auto">Drop your link, we'll handle the rest. Your first viral reel could be in your inbox tomorrow.</p>
        <button onClick={() => onCreate()} data-testid="footer-cta-button"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#FF2E63] hover:bg-[#E02554] text-white font-semibold px-7 py-3.5 transition-colors">
          Create my video <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10">
      <div className="flex items-center gap-2">
        <span className="grid place-items-center w-8 h-8 rounded-lg bg-[#FF2E63]"><Clapperboard className="w-4 h-4 text-white" /></span>
        <span className="font-display font-bold">iTMunch Viral Videos</span>
      </div>
      <p className="text-sm text-slate-500">© {new Date().getFullYear()} iTMunch. All rights reserved.</p>
      <div className="flex items-center gap-5">
        <Link to="/refund-policy" data-testid="footer-refund-policy-link" className="text-sm text-slate-500 hover:text-white transition-colors">Refund Policy</Link>
        <Link to="/admin" className="text-sm text-slate-500 hover:text-white transition-colors">Admin Panel</Link>
      </div>
    </div>
  </footer>
);
